import { Home, ArrowLeft, Search, MapPin } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function NotFound() {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white flex items-center justify-center px-6">
            <div className="max-w-2xl w-full text-center">
                
                {/* 404 Illustration */}
                <div className="mb-8">
                    <h1 className="text-9xl font-bold text-indigo-600 mb-4">404</h1>
                    <div className="flex items-center justify-center gap-2 text-slate-400">
                        <MapPin size={24} />
                        <span className="text-xl">Lost in the journey?</span>
                    </div>
                </div>

                {/* Error Message */}
                <div className="mb-12">
                    <h2 className="text-3xl font-bold text-slate-900 mb-4">
                        Page Not Found
                    </h2>
                    <p className="text-lg text-slate-600 max-w-md mx-auto">
                        Oops! The page you're looking for doesn't exist. 
                        It might have been moved or deleted.
                    </p>
                </div>

                {/* Action Buttons */}
                <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                    <button
                        onClick={() => navigate(-1)}
                        className="flex items-center gap-2 px-8 py-4 rounded-full bg-white border-2 border-slate-300 text-slate-700 font-semibold hover:border-indigo-600 hover:text-indigo-600 transition-all"
                    >
                        <ArrowLeft size={20} />
                        Go Back
                    </button>

                    <button
                        onClick={() => navigate('/')}
                        className="flex items-center gap-2 px-8 py-4 rounded-full bg-indigo-600 text-white font-semibold hover:bg-indigo-700 transition-all shadow-md"
                    >
                        <Home size={20} />
                        Back to Home
                    </button>
                </div>

                {/* Quick Links */}
                <div className="mt-16 pt-8 border-t border-slate-200">
                    <p className="text-sm text-slate-600 mb-6">
                        Or explore these popular pages:
                    </p>
                    <div className="flex flex-wrap items-center justify-center gap-4">
                        <button
                            onClick={() => navigate('/trips')}
                            className="px-6 py-2 rounded-full bg-slate-100 text-slate-700 text-sm font-medium hover:bg-indigo-50 hover:text-indigo-600 transition-all"
                        >
                            All Trips
                        </button>
                        <button
                            onClick={() => navigate('/bangalore-city-tour')}
                            className="px-6 py-2 rounded-full bg-slate-100 text-slate-700 text-sm font-medium hover:bg-indigo-50 hover:text-indigo-600 transition-all"
                        >
                            City Tour
                        </button>
                        <button
                            onClick={() => navigate('/contact')}
                            className="px-6 py-2 rounded-full bg-slate-100 text-slate-700 text-sm font-medium hover:bg-indigo-50 hover:text-indigo-600 transition-all"
                        >
                            Contact Us
                        </button>
                    </div>
                </div>

            </div>
        </div>
    );
}